let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("OBAxr")).then(() => parcelRequire('d6iMp'));